// src/helpers.ts
function parseCookies(cookieHeader) {
  const cookieRegexp = /([^;=\s]*)=([^;]*)/g;
  const cookies = {};
  for (let m; m = cookieRegexp.exec(cookieHeader); ) {
    const [, cookieName, cookieValue] = m;
    cookies[decodeURIComponent(cookieName)] = decodeURIComponent(cookieValue);
  }
  return cookies;
}

export { parseCookies };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-KNI6RYY6.mjs.map